import React from 'react';
import { Field } from 'formik';

import styles from './expertiseFormStyles';

import CheckboxesField from 'buyside/components/presentation/Form/Field/CheckboxesField/checkboxesField';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

const {
  sectorNames,
  geographyNames,
  assetClassNames
} = require('buyside/util/constantsFromRails.json');

// NOTE: make sure to update the appropriate schema in util/fundProfileShowPageValidationSchemata

const ExpertiseForm = () => {
  return (
    <div>
      <div className={styles.expertiseFormSection}>
        <h4 className={styles.expertiseFormSectionTitle}>Sector</h4>
        <Field
          component={CheckboxesField}
          name="fundProfile.sectorExpertise"
          options={sectorNames}
          numColumns={3}
        />
      </div>
      <div className={styles.expertiseFormSection}>
        <h4 className={styles.expertiseFormSectionTitle}>Geographic</h4>
        <Field
          component={CheckboxesField}
          name="fundProfile.geographicExpertise"
          options={geographyNames}
          numColumns={3}
        />
      </div>
      <div className={styles.expertiseFormSection}>
        <h4 className={styles.expertiseFormSectionTitle}>Asset Class</h4>
        <Field
          component={CheckboxesField}
          name="fundProfile.assetClassExpertise"
          options={assetClassNames}
          numColumns={3}
        />
      </div>
      <div className={styles.expertiseFormSection}>
        <h4 className={styles.expertiseFormSectionTitle}>Subsector</h4>
        <Field
          component={InputField}
          name="fundProfile.subsectorExpertise"
          label="List any subsector expertise here:"
        />
      </div>
    </div>
  );
};

export default ExpertiseForm;
